<template>
    <div class="classify">
        <div :class="['list', border && 'border', active == index && 'active']" @click.stop="change(item, index)" v-for="(item, index) in data" :key="index">
            <slot :item="item" :index="index">
                {{ labelKey ? item?.[labelKey] : item }}
            </slot>
        </div>
    </div>
</template>

<script setup>
const emits = defineEmits(['update:active', 'change'])

const props = defineProps({
    data: {
        type: [Array],
        default: () => [],
    },
    active: {
        type: [String, Number],
        default: '',
    },
    border: {
        type: [Boolean],
        default: true,
    },
    labelKey: {
        type: [String],
        default: '',
    },
})

function change(item, index) {
    emits('update:active', index)
    emits('change', index, item)
}
</script>

<style lang="scss" scoped>
.classify {
    gap: 24px;
    display: flex;
    flex-flow: wrap;
    align-items: center;
    justify-content: center;
    .list {
        color: #222222;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        padding-bottom: 4px;
        position: relative;
        cursor: pointer;
        &:hover {
            color: #1677ff;
        }
        &.active {
            color: #1677ff;
            &.border {
                &::after {
                    content: '';
                    position: absolute;
                    left: 25%;
                    bottom: 0;
                    width: 50%;
                    height: 2px;
                    background: #1677ff;
                }
            }
        }
    }
}
</style>
